import { Container, Divider, Stack, Title } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { OrgTemplateSection } from "../features/branchNameTemplate/OrgTemplateSection";
import { RepoTemplateSection } from "../features/branchNameTemplate/RepoTemplateSection";

// Страница «Настройки → Шаблон имени ветки». Тонкий контейнер над
// секцией org-дефолта и секцией per-repo override — как
// `SettingsTrustRulesPage`.
export function BranchNameTemplatePage(): ReactElement {
  const { t } = useTranslation();
  return (
    <Container py="xl">
      <Stack gap="xl">
        <Title order={1}>{t("branchNameTemplate.pageTitle")}</Title>
        <OrgTemplateSection />
        <Divider />
        <RepoTemplateSection />
      </Stack>
    </Container>
  );
}
